export const getWhatsNewPageConfig = ()=>{
    return {
        withFullstory: true,
        enableHotjar: true,
        fullstoryRecordingFrequency: 25,
        hotjarFinalDate: new Date(2024, 4, 1)
    };
};
